// extracted by mini-css-extract-plugin
export default {"button":"nn-z","reviewSort":"on-z"};